// What is waiting for the signed-in user: questions agents asked in the current organisation,
// and devices waiting to be approved. The bell, the sidebar badges and the phone tab bar read
// it; a host without the questions endpoint (before row S38) simply reports none.
import { useQuery } from "@tanstack/react-query";

import type { Device } from "../api/client";
import { devicesQuery } from "../api/queries";
import { type PendingQuestion, pendingQuestionsQuery } from "../dashboard/api";
import { useCurrentOrg } from "./currentOrg";

export interface Attention {
  questions: PendingQuestion[];
  pendingDevices: Device[];
}

export function useAttention(): Attention {
  const { org } = useCurrentOrg();
  const questions = useQuery({ ...pendingQuestionsQuery(org?.id ?? ""), enabled: org !== undefined });
  const devices = useQuery(devicesQuery());
  return {
    questions: questions.data ?? [],
    pendingDevices: (devices.data ?? []).filter((d) => d.status === "pending"),
  };
}
